export const APP_ROUTES_PATHS ={
    HOME_PATH: "/",
    BILLING_PATH: "/billing",
    ADMIN_PANEL_PATH: "/admin",
    RECENT_ORDERS_PATH: "/recent-orders",
    PRINTER_SETTINGS_PATH: "/printer-settings",
    PRINTER_REGISTER_PATH: "/printer-register",
    PRINTER_TEST_PATH: "/printer-test",
    REPORTS_PATH: "/reports"
}
